import { PropertyType } from './PropertyType';

export const multiSelects = [
    PropertyType.MultiGroup,
    PropertyType.MultiGroupType,
    PropertyType.ApprovalMultiLevel,
    PropertyType.Queries,
    PropertyType.Categories,
    PropertyType.VariableTypes,
    PropertyType.Severities,
    PropertyType.TicketStatusMultiLevel,
    PropertyType.AlarmCategories,
    PropertyType.MultiQuality,
    PropertyType.MultiCategory,
    PropertyType.DashboardSelector,
    PropertyType.MultiSelect,
    PropertyType.Symbol,
    PropertyType.QuerySearchBar
];